<template>
  <div class="pharmacyPerformance">
    <el-tabs class="tab" v-model="active" type="border-card">
      <el-tab-pane label="配方业绩" name="formula">
        <FormulaPerformance v-if="active === 'formula'"></FormulaPerformance>
      </el-tab-pane>
      <el-tab-pane label="加工业绩" name="process">
        <ProcessPerformance v-if="active === 'process'"></ProcessPerformance>
      </el-tab-pane>
      <el-tab-pane label="打包业绩" name="pack">
        <PackPerformance v-if="active === 'pack'"></PackPerformance>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import FormulaPerformance from './FormulaPerformance';
  import ProcessPerformance from './ProcessPerformance';
  import PackPerformance from './PackPerformance';
  export default {
    name: 'pharmacyPerformance',
    components: {
      FormulaPerformance,
      ProcessPerformance,
      PackPerformance
    },
    data() {
      return {
        active: 'formula'
      }
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  .pharmacyPerformance{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .tab{
    height: fit-content;
  }

  .tab.el-tabs /deep/ .el-tabs__content{
    display: block;
  }
</style>
